import { isolateComponent } from '@zapier/style-encapsulation';
import { BrandButton } from '@zapier/design-system';
const UniversalSidebarSubheaderButton = (props) => {
    return (isolateComponent(BrandButton, Object.assign({ ariaLabel: props.text, iconBefore: props.iconName, hasShadow: true, href: props.href, isFullWidth: true }, (props.isCollapsed && { color: 'brand-nav' }), { size: "medium" }), !props.isCollapsed && props.text));
};
export default UniversalSidebarSubheaderButton;
//# sourceMappingURL=UniversalSidebarSubheaderButton.js.map
// @zapier/universal-layout@8.3.7 (9c955f548)
